import React from "react";
import { Badge } from "@lemonadetraining/web-ui";
import { IconSquareFilled, IconSquare } from "@tabler/icons-react";

interface EffortIndicatorProps {
  level?: number;
}

function EffortIndicator({ level }: EffortIndicatorProps) {
  if (level == null) return null;

  const clamped = Math.max(0, Math.min(5, Math.round(level)));

  return (
    <div data-testid="effort-indicator">
      <Badge className="bg-background/80 backdrop-blur-sm">
        <span
          role="img"
          aria-label={`Effort level: ${clamped} out of 5`}
          className="flex items-center gap-0.5"
        >
          {Array.from({ length: 5 }, (_, i) =>
            i < clamped ? (
              <IconSquareFilled
                key={i}
                size="1em"
                className="text-amber-400"
                data-testid="icon-filled"
              />
            ) : (
              <IconSquare
                key={i}
                size="1em"
                className="text-amber-400/30"
                data-testid="icon-empty"
              />
            )
          )}
          <span className="sr-only md:not-sr-only text-xs ml-1">{clamped}/5</span>
        </span>
      </Badge>
    </div>
  );
}

export default EffortIndicator;
